import { IServicePackageSchema } from '../../../../repositories/billing-tariffs/v1/publish-terms';

export function getPackageId(servicePackage: IServicePackageSchema): string {
  const {
    tariffIdentificator: { tariffId, tariffGridType },
  } = servicePackage;

  return `${tariffId}${tariffGridType}`;
}
